import { SVGProps, ReactElement } from 'react';

export function ThreeDots(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg fill='#757575' height='4' width='16' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M2.011 3.494a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8.017 3.523a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM14.02 3.542a1.5 1.5 0 100-3 1.5 1.5 0 000 3z' />
    </svg>
  );
}
